import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  projectRoundID: null,
  projectID: null,
  projectName: '',
  projectVendorInfo: '',
  allProjectDetails: {},
  encodedProjectId: null,
  isProjectOwner: false,
}

let user = null
let isAdmin = false
let email = ''
try {
  user = localStorage.getItem('uname')
  const userObject = JSON.parse(user)
  isAdmin = userObject?.user_roles?.some(
    (role) => role.group_name === 'Admin' || role.group_name === 'RFx_Admin',
  )
  email = userObject?.email || ''
} catch (err) {
  console.error('Error parsing user data from localStorage:', err)
}

export const projectInfoSlice = createSlice({
  name: 'project-configuration-rfx',
  initialState,
  reducers: {
    setProjectRoundID: (state, action) => {
      state.projectRoundID = action.payload
    },
    setProjectID: (state, action) => {
      state.projectID = action.payload
    },
    setProjectName: (state, action) => {
      state.projectName = action.payload
    },
    setProjectVendorInfo: (state, action) => {
      state.projectVendorInfo = action.payload
    },
    setAllProjectDetails: (state, action) => {
      state.allProjectDetails = action.payload
      if (!user) {
        const user = localStorage.getItem('uname')
        const userObject = JSON.parse(user)
        email = userObject?.email || ''
        isAdmin = userObject?.user_roles?.some(
          (role) => role.group_name === 'Admin' || role.group_name === 'RFx_Admin',
        )
      }
      const list = [
        ...action.payload.cc_user_email.split(',').map((email) => email?.trim()?.toLowerCase()),
        action?.payload?.email_id?.trim()?.toLowerCase(),
      ]
      state.isProjectOwner = isAdmin || list.includes(email?.trim()?.toLowerCase())
    },
    setRoundIdForAllProjectDetails: (state, action) => {
      state.allProjectDetails = { ...state.allProjectDetails, round_id: action.payload }
    },
    setRoundNumberForAllProjectDetails: (state, action) => {
      state.allProjectDetails = { ...state.allProjectDetails, round_number: action.payload }
    },
    setEncodedProjectId: (state, action) => {
      state.encodedProjectId = action.payload
    },
    setIsProjectOwner: (state, action) => {
      if (!user) {
        const user = localStorage.getItem('uname')
        const userObject = JSON.parse(user)
        isAdmin = userObject?.user_roles?.some(
          (role) => role.group_name === 'Admin' || role.group_name === 'RFx_Admin',
        )
      }
      state.isProjectOwner = isAdmin || action.payload
    },
  },
})

export const {
  setAllProjectDetails,
  setProjectRoundID,
  setProjectID,
  setProjectName,
  setProjectVendorInfo,
  setRoundIdForAllProjectDetails,
  setRoundNumberForAllProjectDetails,
  setEncodedProjectId,
  setIsProjectOwner,
} = projectInfoSlice.actions

export default projectInfoSlice.reducer
